import { Component, EventEmitter, Input, Output } from "@angular/core";
import { DataRowComponent } from "../../_component/pagination-client-side/data-row.component";
import { UserService } from "src/app/_services";

@Component({
  selector: "app-equipment-view",
  templateUrl: "./equipment-view.component.html",
  styleUrls: [
    "./equipment-view.component.scss",
    "./../../../_styles/ion-grid-content-table.scss",
  ],
})
export class EquipmentViewComponent implements DataRowComponent {
  @Input()
  row: any;

  @Input()
  displayMobileView = false;

  @Input()
  styleClass;

  @Output()
  refreshRequest: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  actionRequest: EventEmitter<any> = new EventEmitter<any>();

  canEdit: boolean = false;

  constructor(
    public userServ: UserService
  ) {}

  async ngOnInit() {
    this.canEdit = await this.userServ.hasRolesAsync(['equipment.edit']);
  }

  async onEditClick(id: number) {
    if(this.canEdit) {
      this.actionRequest.emit({
        type: "edit",
        id: this.row.id,
      });
    };
  }
}
